import { render, staticRenderFns } from "./purchaserSelect.vue?vue&type=template&id=3c00d22e&scoped=true"
import script from "./purchaserSelect.vue?vue&type=script&lang=js"
export * from "./purchaserSelect.vue?vue&type=script&lang=js"
import style0 from "./purchaserSelect.vue?vue&type=style&index=0&id=3c00d22e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c00d22e",
  null
  
)

export default component.exports